window.openAddCardDetail = btn => {
  const AddCardDetailComponent = btn.nextElementSibling
  AddCardDetailComponent.classList.remove('hidden')
  AddCardDetailComponent.classList.add('flex')
}

